export default __webpack_public_path__ + "static/media/dermaheal1.f678cdd9.jpg";